import { Button, styled, Typography } from "@material-ui/core";

export const ImageWrapper = styled(`div`)(({ theme }) => ({
  margin: theme.spacing(3, 2, 4),
  "& img": {
    maxWidth: "100%"
  },
  [theme.breakpoints.up(`md`)]: {
    margin: theme.spacing(8, 0, 6)
  }
}));

export const CustomDescriptionTypography = styled(Typography)(({ theme }) => ({
  maxWidth: `564px`,
  padding: theme.spacing(0, 3),
  margin: theme.spacing(4, 0, 3),
  [theme.breakpoints.up(`md`)]: {
    margin: theme.spacing(3, 0, 3)
  }
}));

export const CustomTipsTypography = styled(Typography)(({ theme }) => ({
  display: "block",
  maxWidth: `500px`,
  padding: theme.spacing(0, 3),
  marginTop: theme.spacing(3)
}));

export const CustomButtonWrapper = styled(`div`)(({ theme }) => ({
  width: `100%`,
  padding: theme.spacing(0, 2),
  [theme.breakpoints.up(`sm`)]: {
    width: `288px`
  }
}));
